import { FONT_SCALE } from '@editor/src/page/index/components/editor/config';
import { browser } from '@utils/agent';

export const isTitleElement = (element) => {
    const type = element?.placeHolder?.type;
    return type === 'title' || type === 'ctrTitle';
};

export function getPadding(padding, defaultValue) {
    const p = typeof (padding) === 'undefined' ? defaultValue : parseFloat(padding);
    return parseInt(String(p * FONT_SCALE), 10); // 去小数
}

export function getFontScale() {
    if (browser.isAndroid && !browser.isWeChat) {
        try {
            const $dom = document.createElement('div');
            $dom.style.cssText = 'font-size:20px;';
            document.body.appendChild($dom);
            // 计算出放大后的字体
            const scaledFontSize = parseInt(window.getComputedStyle($dom, null).getPropertyValue('font-size'));
            document.body.removeChild($dom);
            // 计算原字体和放大后字体的比例
            return 20 / scaledFontSize;
        } catch (e) {
            console.warn('getFontScale error');
        }
    }
    return 1;
}
